export default "/images/document.svg?b273567aea1c0a9b8e1a53e202ff5f34";